import { useEffect, useState } from 'react';
import useRouterQueryId from '../../../../hooks/useRouterQueryId';
import { eventNames } from '../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../utils/GTM/useTrackMixpanelEvent';
import { countTotalNotes } from '../utils/count';
import useNoteIdMetadataQuery from './queries/useNoteIdMetadataQuery';
import useNoteIdWithUnitsQuery from './queries/useNoteIdWithUnitsQuery';

export const useTrackPageViewOnFirstEnter = () => {
  const courseNoteId = useRouterQueryId();

  const { data: noteData } = useNoteIdWithUnitsQuery({
    id: courseNoteId,
  });
  const { data: metadata } = useNoteIdMetadataQuery(courseNoteId);

  const [isFirstEnter, setIsFirstEnter] = useState(true);
  const { trackMixpanelEvent, isReady } = useTrackMixpanelEvent();

  useEffect(() => {
    if (isFirstEnter && isReady && noteData && metadata) {
      trackMixpanelEvent(eventNames.VIEW_MY_NOTES, {
        course_identification: String(noteData.course.id),
        note_count: countTotalNotes(noteData.sections),
        is_public: metadata.isPublic,
      });
      setIsFirstEnter(false);
    }
  }, [noteData, metadata, isReady, isFirstEnter, trackMixpanelEvent]);
};

export const useTrackNoteShareEvent = () => {
  const courseNoteId = useRouterQueryId();

  const { data: noteData } = useNoteIdWithUnitsQuery({ id: courseNoteId });

  const { trackMixpanelEvent, isReady } = useTrackMixpanelEvent();

  const trackNoteShareClickEvent = () => {
    if (isReady && noteData) {
      trackMixpanelEvent(eventNames.CLICK_SHARE_NOTES, {
        course_identification: String(noteData.course.id),
        note_count: countTotalNotes(noteData.sections),
      });
    }
  };

  return { trackNoteShareClickEvent };
};
